

import { TabStyles } from '@tableau/widgets';
import { divWithStyle } from '../../../style';
import { buttonContainerDiv, helpTextDiv, inputHintDiv, textAreaCssClass } from './ExternalContentActionsStyles';

export const DATA_QUALITY_DIALOG_TEST_ID: string = 'data-quality-dialog';
export const DATA_QUALITY_DIALOG_TOGGLE_TEST_ID: string = DATA_QUALITY_DIALOG_TEST_ID + '-toggle';
export const DATA_QUALITY_DIALOG_TYPE_TEST_ID: string = DATA_QUALITY_DIALOG_TEST_ID + '-type';
export const DATA_QUALITY_DIALOG_CANCEL_TEST_ID: string = DATA_QUALITY_DIALOG_TEST_ID + '-cancel';
export const DATA_QUALITY_DIALOG_SAVE_TEST_ID: string = DATA_QUALITY_DIALOG_TEST_ID + '-save';
export const DATA_QUALITY_DIALOG_MESSAGE_ID: string = DATA_QUALITY_DIALOG_TEST_ID + '-message';

export const DROPDOWN_WIDTH: number = 200;
export const TEXT_AREA_HEIGHT: number = 100;

export const ContentItemNameDiv = divWithStyle(DATA_QUALITY_DIALOG_TEST_ID, '-content-item-name-text', {
  marginBottom: TabStyles.Spacing.MediumSpace,
  fontSize: TabStyles.Typography.Sizing.Tiny,
  color: TabStyles.Typography.Color.Primary,
});

export const HelpTextDiv = helpTextDiv(DATA_QUALITY_DIALOG_TEST_ID);

export const DropDownPromptDiv = divWithStyle(DATA_QUALITY_DIALOG_TEST_ID, '-dropdown-prompt-text', {
  paddingTop: TabStyles.Spacing.MediumSpace,
  paddingBottom: TabStyles.Spacing.MediumSpace,
});

export const InputHintDiv = inputHintDiv(DATA_QUALITY_DIALOG_TEST_ID);

export const ButtonContainerDiv = buttonContainerDiv(DATA_QUALITY_DIALOG_TEST_ID);

export const dropDownStyle: React.CSSProperties = {
  width: DROPDOWN_WIDTH,
  marginBottom: TabStyles.Spacing.ExtraLargeSpace,
};

export const textAreaClass = textAreaCssClass(DATA_QUALITY_DIALOG_TEST_ID, TEXT_AREA_HEIGHT);

export const checkboxStyle: React.CSSProperties = {
  marginTop: TabStyles.Spacing.DefaultSpace,
  marginBottom: TabStyles.Spacing.DefaultSpace,
};
